<template>
  <v-row>
    <v-col>
      <v-card>
        <general-error v-if="!!generalError" />
        <v-row class="px-3">
          <v-col cols="12" sm="6" class="mr-4">
            <orders-creator-selection
                v-if="lot && lot.lotId"
                v-model="params.organizationId"
                :label="$t('Участник')"
                :lot-id="lot.lotId"
                :lot-type="lot.lotType"
                :readonly="isLoading"
                @change="search" />
          </v-col>
          <v-col class="text-right">
            <btn-icon-tip
                v-if="isDivisibleVolume && isAdmin"
                :btn-color="$vuetify.breakpoint.smAndUp
                  ? 'primary'
                  : ''"
                :icon-color="$vuetify.breakpoint.xsOnly
                  ? 'primary'
                  : ''"
                :icon="$vuetify.breakpoint.xsOnly
                  ? 'insert_chart_outlined'
                  : ''"
                :disabled="isLoading"
                :tip="$t('Выгрузить статистику')"
                @click="getOffersStatistics" />
                &nbsp;
            <btn-icon-tip
                v-if="canGetOfferRegistry"
                :btn-color="$vuetify.breakpoint.smAndUp
                  ? 'primary'
                  : ''"
                :icon-color="$vuetify.breakpoint.xsOnly
                  ? 'primary'
                  : ''"
                :icon="$vuetify.breakpoint.xsOnly
                  ? 'list'
                  : ''"
                :tip="$t('Выгрузить Реестр ценовых предложений')"
                :disabled="isLoading"
                @click="getLotOffersRegistry" />
          </v-col>
        </v-row>
        <v-card-text>
          <v-row>
            <v-col>
              <paginated-data-table
                  v-if="getTradeResultsList"
                  ref="paginatedTable"
                  :headers="headers1"
                  :items="orders"
                  t-class="elevation-1 orders"
                  :loading="isLoading"
                  item-key="orderId"
                  :total-count="totalCount"
                  :items-per-page="itemsPerPage"
                  show-expand
                  :expanded.sync="expanded"
                  :request-method="getTradeResultsList">
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.organizationName="{ item }">
                  <route-link-with-tip
                      v-if="isAdmin"
                      :text="item.organizationName"
                      :tip="$t('Просмотр организации')"
                      :to="{ path: `${urlRootPath}/organization/${item.organizationId}` }" />
                  <span v-else>
                    {{ item.organizationName }}
                  </span>
                </template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.contactPerson="{ item }">
                  <route-link-with-tip
                      v-if="isAdmin"
                      :text="item.contactPerson"
                      :tip="$t('Просмотр пользователя')"
                      :to="{ path: `${urlRootPath}/user/${item.userId}` }" />
                  <span v-else>
                    {{ item.contactPerson }}
                  </span>
                </template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.sessionNumber="{ item }">
                  {{ item.sessionNumber }}
                </template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.orderDate="{ item }">
                  {{ item.orderDate
                    ? $moment(item.orderDate).format('DD.MM.YYYY HH:mm:ss')
                    : null }}
                </template>
                <!-- eslint-disable-next-line  vue/no-template-shadow, vue/valid-v-slot -->
                <template v-slot:item.clientOrganizationFullName="{ item }">
                  <template v-if="item.clientOrganizationFullName && item.clientOrganizationInn">
                    {{ item.clientOrganizationFullName }} / {{ item.clientOrganizationInn }}
                  </template>
                </template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.isWinner="{ item }">
                  <v-checkbox
                      v-model="item.isWinner"
                      dense
                      :color="item.isWinner
                        ? 'success'
                        : null"
                      :height="10"
                      disabled />
                </template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.isActive="{ item }">
                  <icon-tip
                      :icon="item.isActive
                        ? 'check_circle'
                        : 'block'"
                      :icon-color="item.isActive
                        ? 'success'
                        : 'error'"
                      :tip="item.isActive
                        ? $t('Активная')
                        : $t('Отозвана')" />
                </template>
                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length">
                    <v-row v-if="!isDivisibleVolume">
                      <v-col :cols="item.fileId ? 9 : 12" class="my-2">
                        <v-data-table
                            :key="item.orderId"
                            :headers="headers2"
                            :items="item.premiums || []"
                            :items-per-page="nestedItemsPerPage"
                            item-key="positionId"
                            class="premiums"
                            disable-sort-by
                            dense
                            hide-default-footer
                            :locale="systemLocale">
                          <!-- eslint-disable-next-line  vue/no-template-shadow, vue/valid-v-slot -->
                          <template v-slot:item.positionDescription="{ item }">
                            {{ item.positionDescription }}
                          </template>
                          <!-- eslint-disable-next-line  vue/no-template-shadow, vue/valid-v-slot -->
                          <template v-slot:item.premium="{ item }">
                            {{ item.premium }}
                          </template>
                          <!-- eslint-disable-next-line  vue/no-template-shadow, vue/valid-v-slot -->
                          <template v-slot:item.orderCost="{ item }">
                            {{ item.orderCost }}
                          </template>
                        </v-data-table>
                      </v-col>
                      <v-col v-if="item.fileId" cols="3">
                        <v-row class="px-2 py-2 pb-0 mb-0">
                          <v-col class="pb-0 mb-0">
                            <v-icon>
                              link
                            </v-icon>
                            {{ $t('Дополнительно') }}
                          </v-col>
                        </v-row>
                        <v-row v-if="item.additionalInfo" class="px-2 pt-2 pb-0 mb-0">
                          <v-col class="pb-0 mb-0">
                            <v-textarea
                                :value="item.additionalInfo"
                                readonly
                                solo
                                rows="2"
                                dense />
                          </v-col>
                        </v-row>
                        <v-row
                            v-if="item.fileId"
                            class="px-2 pb-2 pt-0 mt-0"
                            align="center">
                          <text-view
                              :cols="10"
                              align-self="center"
                              :label="$t('Прикрепленные документы')"
                              :display="' '" />
                          <v-col cols="2" align-self="center">
                            <btn-icon-tip
                                icon="get_app"
                                :tip="$t('Скачать документ')"
                                @click="getBusinessFile(item.fileId)" />
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-row v-else>
                      <v-col :cols="item.fileId ? 9 : 12" class="my-2">
                        <v-data-table
                            :key="item.orderId"
                            :headers="headers3"
                            :items="[ item ]"
                            :items-per-page="nestedItemsPerPage"
                            class="premiums"
                            disable-sort-by
                            item-key="orderId"
                            dense
                            hide-default-footer
                            :locale="systemLocale">
                          <!-- eslint-disable-next-line  vue/no-template-shadow, vue/valid-v-slot -->
                          <template v-slot:item.positionDescription="{ item }">
                            {{ item.positionDescription }}
                          </template>
                          <!-- eslint-disable-next-line  vue/no-template-shadow, vue/valid-v-slot -->
                          <template v-slot:item.premium="{ item }">
                            {{ item.premium }}
                          </template>
                          <!-- eslint-disable-next-line  vue/no-template-shadow, vue/valid-v-slot -->
                          <template v-slot:item.requestedPartsCount="{ item }">
                            {{ item.requestedPartsCount }}
                          </template>
                          <!-- eslint-disable-next-line  vue/no-template-shadow, vue/valid-v-slot -->
                          <template v-slot:item.satisfiedVolume="{ item }">
                            {{ item.requestedPartsCount }}
                          </template>
                          <!-- eslint-disable-next-line  vue/no-template-shadow, vue/valid-v-slot -->
                          <template v-slot:item.reassignedSatisfiedVolume="{ item }">
                            {{ item.requestedPartsCount }}
                          </template>
                        </v-data-table>
                      </v-col>
                      <v-col v-if="item.additionalInfo || item.fileId" cols="3">
                        <v-row class="px-2 py-2 pb-0 mb-0">
                          <v-col class="pb-0 mb-0">
                            <v-icon>
                              link
                            </v-icon>
                            {{ $t('Дополнительно') }}
                          </v-col>
                        </v-row>
                        <v-row v-if="item.additionalInfo" class="px-2 pt-2 pb-0 mb-0">
                          <v-col class="pb-0 mb-0">
                            <v-textarea
                                :value="item.additionalInfo"
                                readonly
                                solo
                                rows="2"
                                dense />
                          </v-col>
                        </v-row>
                        <v-row
                            v-if="item.fileId"
                            class="px-2 pb-2 pt-0 mt-0"
                            align="center">
                          <text-view
                              :cols="10"
                              align-self="center"
                              :label="$t('Прикрепленные документы')"
                              :display="' '" />
                          <v-col cols="2" align-self="center">
                            <btn-icon-tip
                                icon="get_app"
                                :tip="$t('Скачать документ')"
                                @click="getBusinessFile(item.fileId)" />
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </td>
                </template>
              </paginated-data-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<style scoped>
  .orders::v-deep td:nth-child(3) {
   word-break: break-all;
   max-width: 450px;
  }
  .orders::v-deep td:nth-child(1) {
    min-width: 200px;
  }
  .premiums::v-deep td:nth-child(1) {
    word-break: break-all;
    max-width: 550px;
  }
  .premiums::v-deep td:nth-child(2) {
    min-width: 150px;
  }
</style>

<script>

  import RouteLinkWithTip from '@/components/reused/ui/RouteLinkWithTip.vue'
  import BtnIconTip from '@/components/reused/ui/BtnIconTip.vue'
  import IconTip from '@/components/reused/ui/IconTip.vue'
  import TextView from '@/components/reused/ui/TextView.vue'
  import OrdersCreatorSelection from '@/components/reused/ui/OrdersCreatorSelection.vue'
  import PaginatedDataTable from '@/components/reused/ui/PaginatedDataTable.vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import { mapActions, mapState } from 'vuex'
  import { LOT_ORDERS, LOT_DOCUMENT_GENERATOR } from '@/constants/store.js'
  import { PREMIUM_TYPES, LOT_TYPES } from '@/constants/business'
  import getFileMixin from '@/utils/mixins/scoped/getFileMixin.js'

  export default {
    components: {
      IconTip,
      TextView,
      BtnIconTip,
      RouteLinkWithTip,
      OrdersCreatorSelection,
      PaginatedDataTable,
      GeneralError
    },
    mixins: [
      getFileMixin('isLoading')
    ],
    props: {
      lot: {
        type: Object,
        required: true
      },
      canGetOfferRegistry: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        isLoading: false,
        nestedItemsPerPage: -1,
        itemsPerPage: 10,
        expanded: [],
        params: {
          organizationId: ''
        }
      }
    },
    computed: {
      isDivisibleVolume () {
        return this.lot.lotType === LOT_TYPES.REQUEST_OFFERS_DIVISIBLE_VOLUME
      },
      ...mapState(LOT_ORDERS.NAMESPACE, {
        ordersInfo: state => (state[LOT_ORDERS.STATE.TRADE_RESULTS] || {})
      }),
      headers1 () {
        let headers = [
          { text: this.$t('Организация'), sortable: false, value: 'organizationName' },
          { text: this.$t('Пользователь'), sortable: false, value: 'contactPerson' },
          { text: this.$t('Клиент'), sortable: false, value: 'clientOrganizationFullName' },
          { text: this.$t('№ сессии'), sortable: false, value: 'sessionNumber' },
          { text: this.$t('Время выставления'), sortable: false, value: 'orderDate' },
          { text: this.$t('Статус'), sortable: false, value: 'isActive' },
          { text: this.$t('Победитель'), sortable: false, value: 'isWinner' },
          { text: '', value: 'data-table-expand' }
        ]
        if (!this.isAdmin) {
          headers = headers.filter(h => h.value !== 'contactPerson')
        }
        return headers
      },
      isFixPremium () {
        return this.lot.premiumType === PREMIUM_TYPES.FIX
      },
      headers2 () {
        let headers = [
          { text: this.$t('Предмет договора'), sortable: false, value: 'positionDescription' },
          { text: this.$t('Цена 1 (одной) углеродной единицы (с учетом НДС)', [this.lot.currency]), sortable: false, value: 'premium' },
          { text: this.$t('Общая стоимость торговой процедуры, {0}', [this.lot.currency]), sortable: false, value: 'orderCost' }
        ]
        if (!this.isFixPremium) {
          headers = headers.filter(h => h.value !== 'orderCost')
        }
        return headers
      },
      headers3 () {
        const headers = [
          { text: this.$t('Предмет договора'), sortable: false, value: 'positionDescription' },
          { text: this.$t('Цена 1 (одной) углеродной единицы (с учетом НДС)', [this.lot.currency]), sortable: false, value: 'premium' },
          { text: this.$t('Количество углеродных единиц (запрошено)'), align: 'start', sortable: false, value: 'requestedPartsCount' },
          { text: this.$t('Объем в ценовом предложении (удовлетворено)'), align: 'start', sortable: false, value: 'satisfiedVolume' },
          { text: this.$t('Назначенный объем'), align: 'start', sortable: false, value: 'reassignedSatisfiedVolume' }
        ]
        return headers
      },
      totalCount () {
        return this.ordersInfo.totalCount || 0
      },
      orders () {
        return this.ordersInfo.items || []
      }
    },
    created () {
      this.clearStore()
    },
    beforeDestroy () {
      this.clearStore()
    },
    methods: {
      ...mapActions(LOT_ORDERS.NAMESPACE, {
        getTradeResultsListAction: LOT_ORDERS.ACTIONS.GET_TRADE_RESULTS_LIST,
        clearTradeResultsListAction: LOT_ORDERS.ACTIONS.CLEAR_TRADE_RESULTS_LIST
      }),
      ...mapActions(LOT_DOCUMENT_GENERATOR.NAMESPACE, {
        getLotOffersRegistryAction: LOT_DOCUMENT_GENERATOR.ACTIONS.GET_LOT_OFFERS_REGISTRY,
        getGeneratedFileForLotAction: LOT_DOCUMENT_GENERATOR.ACTIONS.GET_GENERATED_FILE_FOR_LOT
      }),
      clearStore: async function () {
        await Promise.all(
          [
            this.clearTradeResultsListAction()
          ])
      },
      search: async function () {
        await this.$refs.paginatedTable.resetPaginationAndGetDataFromServer()
      },
      getTradeResultsList: async function (params) {
        try {
          this.isLoading = true
          await this.getTradeResultsListAction({
            params: {
              ...params,
              ...this.params
            },
            lotId: this.lot.lotId,
            lotType: this.lot.lotType
          })

          this.isLoading = false
          this.expanded = this.orders
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      getLotOffersRegistry: async function () {
        try {
          this.isLoading = true
          await this.getLotOffersRegistryAction({
            lotId: this.lot.lotId,
            lotType: this.lot.lotType
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      getOffersStatistics: async function () {
        await this.getGeneratedFileForLot('offersStatistics')
      },
      getGeneratedFileForLot: async function (fileType) {
        try {
          this.isLoading = true
          await this.getGeneratedFileForLotAction({
            lotId: this.lot.lotId,
            lotType: this.lot.lotType,
            fileType
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      }
    }
  }
</script>
